<template>
    <div class="page-wrapper bg-white radius-lg margin-left-sm">
        <div class="tabs-container flex align-center">
            <div v-for="(item,index) in menus" :key="index"
                 :class="[{active:curTab === item.value}]" class="tab" @click="menuChange(item.value)">{{ item.label }}
            </div>
        </div>
        <div class="search-container min flex align-center  justify-between padding-lr margin-top-sm">
            <div class="flex align-center">
                <el-input v-model="keyword" placeholder="请输入单位名称"></el-input>
                <el-button class="search-submit" type="primary" @click="search">搜索</el-button>
            </div>
            <el-button class="btn min bg-orange radius" type="warning" @click="addUnit(false)">
                添加
            </el-button>
        </div>
        <div class="page-list flex flex-direction padding flex-sub">
            <el-table
                v-loading="loading"
                :data="lists"
                border
                header-row-class-name="table-header"
                style="width: 100%">
                <el-table-column label="单位名称" prop="company_name">
                    <template slot-scope="scope">
                        <div class="table-item">
                            {{ scope.row.company_name }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="项目数量" prop="num">
                    <template slot-scope="scope">
                        <div class="table-item">
                            {{ scope.row.num }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" prop="end_time" width="370">
                    <template slot-scope="scope">
                        <div class="table-operate text-center">
                            <el-button class="radius" type="primary" size="small" @click="addUnit(scope.row)">编辑</el-button>
                            <el-button class="radius" type="danger" size="small" @click="delUnit(scope.row)">删除</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                :current-page.sync="page"
                :page-size="limit"
                :total="total"
                background
                class="page-all margin-top self-end"
                layout="prev, pager, next"
                @current-change="init">
            </el-pagination>
        </div>
        <add-units-dialog :dialog-visible="addUnitDialog" :uid="cur_unit_id" :company_name="cur_unit_name" :type="curTab" @watchState="watchState"></add-units-dialog>
    </div>
</template>

<script>

import {level_color, levels, units_menus} from "@/utils/const";
import {delCompany, getCompanyList} from "@/api";
import AddUnitsDialog from "@/views/web/admin/components/AddUnitsDialog";
import {confirm, TOAST, toast} from "@/utils/utils";

export default {
    name: "units",
    components: {AddUnitsDialog},
    data() {
        return {
            menus: units_menus,
            curTab: 1,
            keyword:'',
            lists: [],
            page: 1,
            limit: 10,
            total: 0,
            loading: false,
            cur_unit_id:0,
            cur_unit_name:'',
            addUnitDialog:false,
        }
    },
    created() {
        this.$emit('setIndex', [4,4], '单位管理', false)
        this.init()
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    methods: {
        async init() {
            this.loading = true
            let _data = await getCompanyList(this.curTab,this.keyword,this.page,this.limit)
            this.lists = _data.data.data
            this.total = _data.data.total
            this.loading = false
        },
        menuChange(value) {
            this.curTab = value
            this.search()
        },
        search(){
            this.page = 1
            this.init()
        },
        addUnit(data){
            if (data) {
                this.cur_unit_id = data.id
                this.cur_unit_name = data.company_name
            }
            this.addUnitDialog = true
        },
        watchState(data) {
            if (data) this.init()
            this.cur_unit_id = 0
            this.cur_unit_name = ''
            this.addUnitDialog = false
        },
        delUnit(item){
            confirm(`删除单位`,`你确定删除<b>${item.company_name}</b>单位吗？`,()=>{
                this.delUnitItem(item.id)
            },'确认',true)
        },
        async delUnitItem(id){
            let _data = await delCompany(id)
            if (_data.status === 200) {
                toast(`删除成功`, TOAST.success)
                this.init()
            } else {
                toast(_data.msg, TOAST.error)
            }
        },
    },
    filters:{
        level(val) {
            return levels.find(f => Number(f.value) === val).label
        },
        level_color(val) {
            //"status": 0, //项目状态 0未提交审核 1已提交审核 2进行中 3驳回提交
            return level_color(val)
        }
    }

}
</script>

<style lang="scss" scoped>
.page-wrapper {
}
</style>
